import { apiFunctionsEnum } from 'constants/api.constants';
import ApiService from './api.service';
import { setCompanies, setCompaniesExpendedData } from 'state/reducers/global.reducer';
import {
	setAltshulerAgents,
	setAltshulerDealers,
	setAltshulerEmployees,
	setAltshulerLeads,
	setAltshulerManagers,
	setError,
	setLoading,
} from 'state/reducers/company.reducers';
import {
	setIsLoading,
	setSuccessfullyUpdated,
	setError as accountSetError,
} from 'state/reducers/customer-accounts.reducers';
import { setSuccessMessage } from 'state/reducers/ui.reducers';
import { setErrorMessage } from 'utils/index';
import { formatDateForServer } from 'constants/global.constants';
import _ from 'lodash';

export const getAllCompanies = () => {
	return async (dispatch: any) => {
		dispatch(setLoading(true));
		dispatch(setError({ exist: false }));
		try {
			const response = await ApiService.getInstance().execute(apiFunctionsEnum.GET_COMPANIES);
			const companies = response.data.result;
			dispatch(setCompanies(companies));
			return companies;
		} catch (error: any) {
			setErrorMessage(setError, {
				errorNumber: error?.response?.data?.error_number,
				statusCode: error?.response?.status,
			});
		} finally {
			dispatch(setLoading(false));
		}
	};
};

import { buildPaginationQueryParams, IPaginationParams } from 'utils';

export const getAllCompaniesExpendedData = (params?: IPaginationParams, skipGlobalLoading = false) => {
	return async (dispatch: any) => {
		if (!skipGlobalLoading) {
			dispatch(setLoading(true));
		}
		dispatch(setError({ exist: false }));
		try {
			const queryParams = buildPaginationQueryParams(params, { sortBy: 'created_at' });
			const response = await ApiService.getInstance().execute(
				apiFunctionsEnum.GET_COMPANIES_EXPENDED_DATA,
				queryParams
			);
			dispatch(
				setCompaniesExpendedData({
					data: response.data.result,
					pagination: response.data.pagination,
				})
			);
			return response.data;
		} catch (error: any) {
			setErrorMessage(setError, {
				errorNumber: error?.response?.data?.error_number,
				statusCode: error?.response?.status,
			});
		} finally {
			if (!skipGlobalLoading) {
				dispatch(setLoading(false));
			}
		}
	};
};

export function getAllAltshulerEmployees() {
	return async (dispatch: any) => {
		dispatch(setLoading(true));
		await ApiService.getInstance()
			.execute(apiFunctionsEnum.GET_ALTSHULER_EMPLOYEES, {})
			.then((response: any) => {
				dispatch(setAltshulerEmployees(response.data));
			})
			.catch((error: any) => {
				setErrorMessage(setError, {
					errorNumber: error?.response?.data?.error_number,
					statusCode: error?.response?.status,
				});
			})
			.finally(() => {
				dispatch(setLoading(false));
			});
	};
}

export function editCompanyData({ id, ...rest }: any) {
	return async (dispatch: any) => {
		dispatch(setSuccessfullyUpdated(false));
		dispatch(setIsLoading(true));
		await ApiService.getInstance()
			.execute(apiFunctionsEnum.EDIT_COMPANY_DATA, { id, ...rest })
			.then((response: any) => {
				dispatch(setSuccessfullyUpdated(true));
				dispatch(setSuccessMessage(true));
			})
			.catch((error: any) => {
				if (_.isObject(error?.response?.data?.errors)) {
					const translateObj: object = {};
					_.keys(error?.response?.data?.errors).forEach((key) => {
						_.assign(translateObj, {
							['servers.errors.' + key]: error?.response?.data?.errors[key]?.toLocaleString(),
						});
					});
					dispatch(accountSetError({ exist: true, subText: translateObj }));
				} else {
					setErrorMessage(accountSetError, {
						errorNumber: error?.response?.data?.error_number,
						statusCode: error?.response?.status,
					});
				}
				dispatch(setSuccessfullyUpdated(false));
			})
			.finally(() => {
				dispatch(setIsLoading(false));
			});
	};
}

export function editPaymentStatus({ id, status, isFee }: any, isSuccessfullyUpdatedSkip = true) {
	return async (dispatch: any) => {
		dispatch(setSuccessfullyUpdated(false));
		dispatch(setIsLoading(true));
		await ApiService.getInstance()
			.execute(apiFunctionsEnum.EDIT_PAYMENT_STATUS, { id, status, isFee })
			.then((response: any) => {
				if (!isSuccessfullyUpdatedSkip) {
					dispatch(setSuccessfullyUpdated(true));
				}
				dispatch(setSuccessMessage(true));
			})
			.catch((error: any) => {
				if (_.isObject(error?.response?.data?.errors)) {
					const translateObj: object = {};
					_.keys(error?.response?.data?.errors).forEach((key) => {
						_.assign(translateObj, {
							['servers.errors.' + key]: error?.response?.data?.errors[key]?.toLocaleString(),
						});
					});
					dispatch(accountSetError({ exist: true, subText: translateObj }));
				} else {
					setErrorMessage(accountSetError, {
						errorNumber: error?.response?.data?.error_number,
						statusCode: error?.response?.status,
					});
				}
				dispatch(setSuccessfullyUpdated(false));
			})
			.finally(() => {
				dispatch(setIsLoading(false));
			});
	};
}

export function editContactData({ contact, ...rest }: any) {
	return async (dispatch: any) => {
		dispatch(setSuccessfullyUpdated(false));
		if (rest.dateOfBirth) {
			rest.dateOfBirth = formatDateForServer(rest.dateOfBirth);
		}
		if (rest.country) {
			rest.countryId = rest.country.id;
		}
		if (rest.statusHebrew) {
			rest.status = rest.statusHebrew;
		}
		if (rest.statusHebrew) {
			rest.status = rest.statusHebrew;
		}
		if (rest.rejectReason) {
			rest.boNotes = rest.rejectReason;
		}
		dispatch(setIsLoading(true));
		await ApiService.getInstance()
			.execute(apiFunctionsEnum.EDIT_CONTACT_DATA, { contact, ...rest })
			.then((response: any) => {
				dispatch(setSuccessfullyUpdated(true));
				dispatch(setSuccessMessage('action.success.contact'));
			})
			.catch((error: any) => {
				if (_.isObject(error?.response?.data?.errors)) {
					const translateObj: object = {};
					_.keys(error?.response?.data?.errors).forEach((key) => {
						_.assign(translateObj, {
							['servers.errors.' + key]: error?.response?.data?.errors[key]?.toLocaleString(),
						});
					});
					dispatch(accountSetError({ exist: true, subText: translateObj }));
				} else {
					setErrorMessage(accountSetError, {
						errorNumber: error?.response?.data?.error_number,
						statusCode: error?.response?.status,
					});
				}
				dispatch(setSuccessfullyUpdated(false));
			})
			.finally(() => {
				dispatch(setIsLoading(false));
			});
	};
}

export function editBankAccountData({ id, ...rest }: any) {
	return async (dispatch: any) => {
		dispatch(setSuccessfullyUpdated(false));
		dispatch(setIsLoading(true));
		if (_.has(rest, 'statusHebrew')) {
			_.assign(rest, { status: rest['statusHebrew'] });
		}
		await ApiService.getInstance()
			.execute(apiFunctionsEnum.EDIT_BANK_ACCOUNTS_DATA, { id, ...rest })
			.then((response: any) => {
				dispatch(setSuccessfullyUpdated(true));
				dispatch(setSuccessMessage('action.success.bank_account_details'));
			})
			.catch((error: any) => {
				setErrorMessage(setError, {
					errorNumber: error?.response?.data?.error_number,
					statusCode: error?.response?.status,
				});
				dispatch(setSuccessfullyUpdated(false));
			})
			.finally(() => {
				dispatch(setIsLoading(false));
			});
	};
}

export function editBeneficiaryData({ id, ...rest }: any) {
	return async (dispatch: any) => {
		dispatch(setSuccessfullyUpdated(false));
		dispatch(setIsLoading(true));
		if (rest.statusHebrew) {
			rest.status = rest.statusHebrew;
		}
		await ApiService.getInstance()
			.execute(apiFunctionsEnum.EDIT_BENEFICIARY, { id, ...rest })
			.then((response: any) => {
				dispatch(setSuccessfullyUpdated(true));
				dispatch(setSuccessMessage('action.success.beneficiary'));
			})
			.catch((error: any) => {
				setErrorMessage(setError, {
					errorNumber: error?.response?.data?.error_number,
					statusCode: error?.response?.status,
				});
				dispatch(setSuccessfullyUpdated(false));
			})
			.finally(() => {
				dispatch(setIsLoading(false));
			});
	};
}

export function upsertCustomerRelations({ id, ...rest }: any, data: any, boUserId?: any) {
	return async (dispatch: any) => {
		dispatch(setSuccessfullyUpdated(false));
		dispatch(setIsLoading(true));
		await ApiService.getInstance()
			.execute(apiFunctionsEnum.UPSERT_CUSTOMER_RELATIONS, { id, ...rest, boUserId })
			.then((response: any) => {
				dispatch(setSuccessfullyUpdated(true));
				dispatch(setSuccessMessage(true));
				const pointer = {
					altshulerAgents: setAltshulerAgents,
					altshulerManagers: setAltshulerManagers,
					altshulerLeads: setAltshulerLeads,
					altshulerDealers: setAltshulerDealers,
				};
				const func = _.get(pointer, rest.type);
				dispatch(func(_.get(response.data, rest.type)));
			})
			.catch((error: any) => {
				setErrorMessage(setError, {
					errorNumber: error?.response?.data?.error_number,
					statusCode: error?.response?.status,
				});
				dispatch(setSuccessfullyUpdated(false));
			})
			.finally(() => {
				dispatch(setIsLoading(false));
			});
	};
}
